import { RadioGroupExpanderInput } from './Expander';
import { RadioGroupExpanderRoot } from './Root';
export type { RadioGroupExpanderRootProps } from './Root';
export type { RadioGroupExpanderInputProps } from './Expander';

export const RadioGroupExpander = {
  Root: RadioGroupExpanderRoot,
  Expander: RadioGroupExpanderInput,
};
